import { shallowRef } from 'vue'
import { compileData } from '.././../../utils/index'
export function useMergeCell({ tableConfig, isSelection, isIconSelection, seqShow }) {
  const mergeCells = shallowRef([])
  const getMergeCell = ({ data, columnList }) => {
    const mergeCellData = []
    const mergeCellExRow = tableConfig.value?.property?.mergeCellExRow
    if (data?.length > 0 && columnList?.length > 0 && !!mergeCellExRow) {
      const nowColumns = [
        {
          property: 'selection',
          visible: isSelection || isIconSelection,
        },
        {
          property: 'seq',
          visible: seqShow,
        },
        ...columnList,
      ]
      let lastRow = {}
      for (const [rowIndex, row] of data.entries()) {
        for (const [colIndex, column] of nowColumns.entries()) {
          if (
            mergeCellExRow[column.property] &&
            compileData(`{{${mergeCellExRow[column.property]}}}`, { row, lastRow })
          ) {
            const mergeCellItem = mergeCellData.find(
              (item) => item.col === colIndex && item.row + item.rowspan === rowIndex
            )
            if (mergeCellItem) {
              mergeCellItem.rowspan += 1
            } else {
              mergeCellData.push({ row: rowIndex - 1, col: colIndex, rowspan: 2, colspan: 1 })
            }
          }
        }
        lastRow = row
      }
      lastRow = null
    }
    mergeCells.value = mergeCellData
  }

  return {
    ifMergeCells: () => !!tableConfig.value?.property?.mergeCellExRow,
    mergeCells,
    getMergeCell,
  }
}
